// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UVq95kYPDn5Sfy {
  display: block;
  position: relative;
  width: 400px;
  overflow: hidden;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 16px;
  opacity: 1;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  -webkit-backdrop-filter: blur(0);
          backdrop-filter: blur(0);
}
.UVq95kYPDn5Sfy.rhxgZ9jzrjtRnb {
  border: none;
}
.UVq95kYPDn5Sfy.WKhgsm2239I16p {
  cursor: ew-resize;
}
.UVq95kYPDn5Sfy.D80IjCPRdlb9Qj {
  transition: flex 0.2s ease-in-out, opacity 0.2s ease-in, border-radius 0.2s ease-in-out, margin 0.2s ease-in-out, padding 0.2s ease-in-out;
}
@media (prefers-reduced-motion) {
  .UVq95kYPDn5Sfy.D80IjCPRdlb9Qj {
    transition: unset;
  }
}
.UVq95kYPDn5Sfy.V_DRS0yje3iMIb.jaoVqDSINb6Be3 {
  border: none;
}
.UVq95kYPDn5Sfy.EdsA06aNyXQKkG {
  flex: 1 1;
  margin-right: var(--ds-space-075, 6px);
}
.UVq95kYPDn5Sfy:not(.zDaIMrwLJiyU9f):not(.bQiKaQnH_RsO6H):not(.jaoVqDSINb6Be3):first-of-type {
  margin-left: var(--ds-space-075, 6px);
}
.UVq95kYPDn5Sfy:not(.zDaIMrwLJiyU9f):not(.bQiKaQnH_RsO6H):not(.jaoVqDSINb6Be3):last-of-type {
  margin-right: var(--ds-space-075, 6px);
}
.UVq95kYPDn5Sfy.bQiKaQnH_RsO6H {
  flex-grow: 1;
  margin: var(--ds-space-0, 0);
  border: unset;
  border-radius: 0;
}
.UVq95kYPDn5Sfy.jaoVqDSINb6Be3 {
  width: 0px;
  margin: var(--ds-space-0, 0);
  opacity: 0;
}
@media print {
  .UVq95kYPDn5Sfy {
    width: 100%;
    overflow: visible;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `UVq95kYPDn5Sfy`,
	"collapsed": `rhxgZ9jzrjtRnb`,
	"dragging": `WKhgsm2239I16p`,
	"panelTransitions": `D80IjCPRdlb9Qj`,
	"planner": `V_DRS0yje3iMIb`,
	"hidden": `jaoVqDSINb6Be3`,
	"rightmostPanel": `EdsA06aNyXQKkG`,
	"noDividers": `zDaIMrwLJiyU9f`,
	"singlePanel": `bQiKaQnH_RsO6H`
};
export default ___CSS_LOADER_EXPORT___;
